import { REDUCER } from '../reducers/reducersConst';
import dayjs from 'dayjs';

let defaultBasicAnalyticsState = {
  basicAnalyticsData: [],
  basicAnalyticsDate: { year: dayjs().year(), month: dayjs().month() },
  selectedStudentIds: []
};

export let basicAnalytics = (state = defaultBasicAnalyticsState, action) => {
  switch (action.type) {
    case REDUCER.BASIC_ANALYTICS.SET_BASIC_ANALYTICS_DATA:
      return {
        ...state,
        basicAnalyticsData: action.basicAnalyticsData
      };
    case REDUCER.BASIC_ANALYTICS.SET_BASIC_ANALYTICS_DATE:
      return {
        ...state,
        basicAnalyticsDate: action.basicAnalyticsDate
      };
    case REDUCER.BASIC_ANALYTICS.SET_SELECTED_STUDENTS:
      return {
        ...state,
        selectedStudentIds: action.selectedStudentIds || []
      };
    default:
      return state;
  }
};
